import { storeToRefs } from 'pinia'

export function useCuratorProfilePreviousButton() {
  const { $pinia } = useNuxtApp()
  const route = useRoute()
  const { navigateToPreviousPage } = useNavigateToPreviousPage()
  const localePath = useLocalePath()

  const { PREVIOUS, history: ROUTING_HISTORY } = storeToRefs(
    useRoutingStore($pinia),
  )
  const { id: DRAFT_ID } = storeToRefs(useDraftStore($pinia))

  const hasPreviousRoute = computed(() => PREVIOUS.value !== '')

  async function handleChevronClick() {
    const previousRoute = PREVIOUS.value

    /*
     * If the user is in a draft, they've come from the catalog or the recap page.
     * This prevents users from getting stuck in an endless loop where they can't return to the catalog after
     * clicking on other links inside the curator profile such as Spotify playlist stats
     */
    if (
      previousRoute?.includes('recap') ||
      previousRoute?.includes('?step=3')
    ) {
      return await navigateTo(previousRoute)
    } else if (DRAFT_ID.value === Number(route.query.draftId)) {
      const draftCatalogPath = `/draft/${DRAFT_ID.value}/influencers/`

      return await navigateTo({
        path: localePath(draftCatalogPath),
        hash: ROUTING_HISTORY.value.some((prevRoute) =>
          prevRoute.includes(`${draftCatalogPath}#loaded`),
        )
          ? '#loaded'
          : undefined,
      })
    }

    /*
     * For users not coming from drafts, we need to check if they've visited a Spotify playlist stats page.
     * If it was their last visited page, or there's more than 1 entry of Spotify playlist stats in the history,
     * We need to redirect them so they don't get stuck in an endless loop.
     */
    if (
      previousRoute?.includes('/spotify/playlist/') ||
      ROUTING_HISTORY.value.filter((route) =>
        route.includes('/spotify/playlist/'),
      ).length > 1
    )
      return await navigateTo(localePath('/'))

    return await navigateToPreviousPage('/band/homepage/')
  }

  return {
    hasPreviousRoute,
    handleChevronClick,
  }
}
